import { render, staticRenderFns } from "./NavisionPage.vue?vue&type=template&id=6bf60fa5&"
import script from "./NavisionPage.vue?vue&type=script&lang=js&"
export * from "./NavisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports